import { useMemo } from 'react';

import type { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { IpValidationResults } from '@packages/utils/validate-ip-addresses/validate-ip-addresses';

export const useTargetErrors = (results?: IpValidationResults) => {
  const { t } = useTranslation('telemetryScanSchedules', {
    keyPrefix: 'targetValidation',
  });

  return useMemo(() => {
    const targetErrors: FieldError[] = [];

    if (!results) return targetErrors;

    if (results.invalid.size) {
      targetErrors.push({
        message: t('invalidIp', {
          target: [...results.invalid].join(', '),
        }),
        type: 'error',
      });
    }

    if (Object.keys(results.duplicate).length) {
      const allDuplicates = Object.values(results.duplicate).reduce(
        (previousValue: string[], currentValue: Set<string>) =>
          previousValue.concat([...currentValue]),
        [],
      );

      targetErrors.push({
        message: t('duplicateIps', {
          targets: allDuplicates.join(', '),
        }),
        type: 'error',
      });
    }

    return targetErrors;
  }, [results, t]);
};
